import * as React from 'react';
import { SVGProps } from 'react';

const IconFolderCubeInterpretationSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 1.7A.7.7 0 0 1 .7 1h5.886a1 1 0 0 1 .707.293l1.414 1.414A1 1 0 0 0 9.414 3H13a1 1 0 0 1 1 1v8.3a.7.7 0 0 1-.7.7H1a1 1 0 0 1-1-1V1.7Z"
      fill="var(--color-bg-caution)"
    />
    <path
      d="M0 3.7A.7.7 0 0 1 .7 3H13a1 1 0 0 1 1 1v8.3a.7.7 0 0 1-.7.7H1a1 1 0 0 1-1-1V3.7Z"
      fill="var(--color-bg-warning)"
    />
    <path
      d="M14.143 12.286H8.57V9.5h5.572L16 7.643V10.5l-1.857 1.786Z"
      fill="var(--color-bg-success)"
    />
    <path
      d="M14.143 13.214H8.57v-1.857h5.572L16 9.5v1.857l-1.857 1.857Z"
      fill="var(--color-bg-caution)"
    />
    <path
      d="M14.143 15.071H8.57v-1.857h5.572L16 11.357v1.857l-1.857 1.857Z"
      fill="var(--color-bg-alert)"
    />
    <path
      d="m8.571 9.5 2.322-1.857H16L14.184 9.5H8.57Z"
      fill="var(--color-bg-success)"
    />
    <path
      d="M9.071 4.393a.5.5 0 0 0-1 0V9H3.464a.5.5 0 0 0 0 1h3.9l-1.003 1.004a.5.5 0 1 0 .707.707l1.003-1.004v3.9a.5.5 0 1 0 1 0V10h4.608a.5.5 0 0 0 0-1h-3.9l1.003-1.004a.5.5 0 1 0-.707-.707L9.071 8.293v-3.9Z"
      fill="var(--color-typo-primary)"
    />
    <path
      d="M4.504 13.568a.5.5 0 0 1 0-.707l.619-.62a.5.5 0 1 1 .707.708l-.62.619a.5.5 0 0 1-.706 0ZM11.313 6.758a.5.5 0 0 1 0-.707l.62-.619a.5.5 0 0 1 .706.707l-.619.62a.5.5 0 0 1-.707 0Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconFolderCubeInterpretationSizeS;
